import React, { useMemo } from 'react';
import StepsProvider from 'providers/Steps/Steps.provider';
import { Outlet } from 'react-router';
import ListingCreationStepper from '../../../../../components/ListingCreationStepper';
import routes from './routes';
import ListingEditStepWrapper from '../../../components/ListingEditStepWrapper';
import { useLocation } from 'react-router-dom';

const ProfitableGoingConcern: React.FC = () => {
  const { pathname } = useLocation();

  const stepperRoutes = useMemo(
    () => routes.filter(({ labelId }) => labelId),
    [],
  );

  const isTeaserActive = pathname.includes('teaser');

  return (
    <StepsProvider
      steps={stepperRoutes}
      storageKeySuffix="listing-creation-wizard-steps"
      completedSteps={stepperRoutes.length}
    >
      <ListingEditStepWrapper>
        {!isTeaserActive && <ListingCreationStepper />}
        <Outlet />
      </ListingEditStepWrapper>
    </StepsProvider>
  );
};

export default ProfitableGoingConcern;
